module.exports = __webpack_public_path__ + "static/media/why.6bc0576f.png";